import { orderBy } from "lodash";
import type { TaskResponse } from "./tasksApi";

/**
 * Sorts tasks by due date in ascending order.
 * For tasks on the same day, tasks with `due.time` are shown before tasks without time.
 * Tasks that have time are sorted by time in ascending order.
 */
export function sortTasksByDue(tasks: TaskResponse[] = []): TaskResponse[] {
  return orderBy(
    tasks,
    [(task) => task.due.date, (task) => Boolean(task.due.time), (task) => task.due.time ?? ""],
    ["asc", "desc", "asc"],
  );
}
